import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserDataService } from '../../../users/user-data.service';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Subscription, switchMap, tap, throwError } from 'rxjs';
import { LoggerService } from '../../logger.service';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { EmailSearchResult } from '../../../common/obj.lib';

@Component({
  selector: 'casi-email-search',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    FontAwesomeModule
  ],
  templateUrl: './email-search.html',
  styleUrl: './email-search.scss'
})
export class EmailSearch implements OnInit, OnDestroy {

  protected readonly elementId = `casi-email-search-${crypto.randomUUID()}`;

  // @Input() labelText: string = 'Search Database';
  // private _isRequired: boolean = false;
  // @Input() set isRequired(val: boolean) {
  //   this._isRequired = val;
  //   // this.manageEmailValidation();
  // }
  // get isRequired(): boolean {
  //   return this._isRequired;
  // };

  @Input() placeHolder: string = 'Type email address to search...';
  private _forId: string = '';
  @Input() set forId(val: string) {
    this.id = val
    this._forId = val;
  }; //: string = '';
  // @Input({ required: true }) id: string = `casi-email-search-${crypto.randomUUID()}`
  id: string = `casi-email-search-id-${crypto.randomUUID()}`

  private _inputEmail: string = '';
  @Input() set inputEmail(val: string) {
    this._inputEmail = val;
    this.logger.debug(`inputEmailer:setting: `, val);
    // this.searchControl.setValue(val);
  }
  get inputEmail() {
    return this._inputEmail;
  }

  @Input() readOnly: boolean = false;

  @Output() onSearched: EventEmitter<EmailSearchResult> = new EventEmitter();

  // Create a FormControl for the input field
  searchControl = new FormControl('');
  // form: FormGroup;
  searching = signal(false);
  found = signal(false);
  inputWidth = signal<string>('100%');
  searchEmail = signal<string>('');

  private _subs: Subscription[] = [];

  constructor(
    private searchService: UserDataService,
    private logger: LoggerService,
    // private fb: FormBuilder,
    public faIcons: FaIconLibrary
  ) {
    faIcons.addIcons(...all);

    // this.form = this.fb.group({
    //   email: [null, [Validators.email]]
    // });
  }

  //#region Ng Event handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.searchControl.setValue(this.inputEmail);
    this._subs.push(this.searchControl.valueChanges.pipe(
      tap((val) => {
        // this.logger.debug(`tap:val: `, val);
        // this.searching.set(true)
        this.setSearching(true, 'tap');
      }),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(searchTerm => this.searchService.searchEmailExists(searchTerm ?? null)),
      catchError(errorRes => {
        this.logger.error(`error: `, errorRes);
        return EMPTY; // throwError(() => errorRes)
      })
    ).subscribe({
      next: (results) => {
        this.logger.debug(`search:results: `, results, this.searchControl.value);
        this.found.set(!!results);
        // this.searching.set(false);
        this.setSearching(false, 'next');
        this.logger.debug(`search:searching...`, this.searching()); //.toString());
        let returning = EmailSearchResult.create(this.searchControl.value, this.found(),
          results);
        this.onSearched.emit(returning); //{ searchEmail: this.searchControl.value, found: this.found(), ...results });

      },
      error: (err) => {
        this.logger.error(`search:error: `, err.message);
        // this.searching.set(false);
        this.setSearching(false, 'error');
        this.found.set(false);
        this.onSearched.emit(EmailSearchResult.create(this.searchControl.value, false))//{ searchEmail: this.searchControl.value, found: false });
      }
    }))
  }
  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  //#endregion

  //#region Form properties

  // get f() {
  //   return this.form.controls;
  // }
  // get email() {
  //   return this.form.get('email');
  // }

  //#endregion

  private setSearching(flag: boolean = false, source: string = 'Not set') {
    setTimeout(() => {
      this.searching.set(flag);
      this.logger.debug(`setSearching...`, { searching: this.searching(), source }); //.toString());
    });
  }
  // private manageEmailValidation(): void {
  //   this.logger.debug(`manageEmailValidation: `, this.isRequired);
  //   const emailControl = this.email;
  //   emailControl?.clearValidators();

  //   if (this.isRequired) {
  //     emailControl?.addValidators([Validators.required, Validators.email])
  //   } else {
  //     emailControl?.addValidators([Validators.email])
  //   }

  //   emailControl?.updateValueAndValidity();
  // }

}
